import request from '@/utils/zsm-requets'
const enroll = '/zsm/api/enroll/'


/**
 * 通过id获取销售人员信息
 * @param {*} id 
 * @returns 
 */
export function getSellEmployee(id) {
    return request({
        url: enroll + 'getSellEmployee',
        method: 'post',
        data: { id }
    })
}




/**
 * 获取默认销售人员
 * @returns 
 */
export function getAuthority() {
    return request({
        url: enroll + 'getAuthority',
        method: 'get'
    })
}